<template>
  <div class="news" v-if="articleData">
    <div
      class="news-wrap"
      v-for="(item, index) in articleData.articleList"
      :key="index"
      @click="jumpNews(item)"
    >
      <div class="news-img">
        <img :src="item.photoPath" />
      </div>
      <div class="news-title">
        {{ item.title }}
      </div>
    </div>

    <no-data
      :articleData="articleData"
      :loading="loading"
      v-if="!loading && !articleData"
    ></no-data>
  </div>
</template>

<script>
import NoData from '@/components/NoData';

export default {
  components: {
    NoData,
  },
  props: ['articleData'],
  methods: {
    jumpNews(val) {
      this.countClick(val.id);
      if (val.accessoryList.length > 0) {
        window.open(val.accessoryList[0].path, '_blank');
      }
    },
    countClick(id) {
      let replacement = {
        articleID: id,
      };
      this.$api.countClick(replacement).then((res) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.news {
  padding: 0 calc-width(20vw);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.news-wrap {
  display: inline-block;
  margin-top: calc-width(15vw);
  margin-bottom: calc-width(10vw);
}

.news-img {
  img {
    width: calc-width(123vw);
    height: calc-width(169vw);
  }
}

.news-title {
  max-width: calc-width(123vw);
  text-align: center;
  @include text-over;
  font-size: calc-width(12vw);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/News.vue